/* Card de Agendamientos para la pantalla de Inicio (TD-11766).
 * - Próxima cita (con botón "Unirme" si es virtual y ya está el enlace).
 * - Encuestas de satisfacción pendientes.
 * - Agendas disponibles para la persona (según el público de cada una).
 * No pinta nada si no hay ninguna de las tres cosas.
 */
import { IonBadge, IonButton, IonIcon } from "@ionic/react";
import { calendarOutline, chevronForward, starOutline, videocamOutline } from "ionicons/icons";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import AgendaAPI, { AGENDA_CAMBIO, InicioAgenda } from "src/services/agenda";
import { colorCategoria, ESTADO_RESERVA, formatFechaLarga, hora } from "src/utils/agenda";
import "src/pages/Agenda.css";

const AgendaHomeCard: React.FC = () => {
  const history = useHistory();
  const [datos, setDatos] = useState<InicioAgenda | null>(null);

  useEffect(() => {
    let vivo = true;
    const cargar = () =>
      AgendaAPI.inicio()
        .then((d) => vivo && setDatos(d))
        .catch(() => undefined);
    cargar();
    window.addEventListener(AGENDA_CAMBIO, cargar);
    return () => {
      vivo = false;
      window.removeEventListener(AGENDA_CAMBIO, cargar);
    };
  }, []);

  if (!datos) return null;
  const proxima = datos.proximas[0];
  if (!proxima && !datos.disponibles.length && !datos.encuestas.length) return null;

  return (
    <div className="agenda-home">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <strong style={{ fontSize: 15, display: "inline-flex", alignItems: "center", gap: 6 }}>
          <IonIcon icon={calendarOutline} /> Agendamientos
        </strong>
        <IonButton size="small" fill="clear" routerLink="/agenda">
          Ver todo <IonIcon slot="end" icon={chevronForward} />
        </IonButton>
      </div>

      {proxima && (
        <div className="agenda-home-cita" style={{ ["--agenda-color" as any]: colorCategoria(proxima.categoria) }}
          role="button" onClick={() => history.push("/agenda?tab=mis")}>
          <div style={{ fontSize: 12, color: "#6b7280" }}>
            {datos.proximas.length > 1 ? `Tu próxima cita (tenés ${datos.proximas.length})` : "Tu próxima cita"}
          </div>
          <div style={{ fontWeight: 700, color: "#111827" }}>{proxima.titulo}</div>
          <div style={{ fontSize: 13, color: "#374151", textTransform: "capitalize" }}>
            {formatFechaLarga(proxima.fecha_inicio)}
            {proxima.lugar && proxima.modalidad !== "VIRTUAL" ? ` · ${proxima.lugar}` : ""}
          </div>
          {proxima.estado !== "CONFIRMADA" && (
            <IonBadge color={ESTADO_RESERVA[proxima.estado].color} style={{ marginTop: 4 }}>
              {ESTADO_RESERVA[proxima.estado].etiqueta}
            </IonBadge>
          )}
          {proxima.link_virtual ? (
            <IonButton size="small" href={proxima.link_virtual} target="_blank" rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()} style={{ marginTop: 6 }}>
              <IonIcon slot="start" icon={videocamOutline} /> Unirme
            </IonButton>
          ) : (
            proxima.link_desde && (
              <div style={{ fontSize: 12, color: "#6b7280", marginTop: 2 }}>
                El enlace aparece desde las {hora(proxima.link_desde)}
              </div>
            )
          )}
        </div>
      )}

      {datos.encuestas.map((e) => (
        <div key={e.id} className="agenda-aviso warning" role="button" style={{ marginTop: 8, marginBottom: 0, cursor: "pointer" }}
          onClick={() => history.push("/agenda?tab=mis")}>
          <IonIcon icon={starOutline} /> Contanos cómo fue tu cita: {e.titulo}
        </div>
      ))}

      {datos.disponibles.length > 0 && (
        <>
          <div style={{ fontSize: 12, color: "#6b7280", marginTop: 10 }}>Agendas disponibles para vos</div>
          <div className="agenda-home-temas">
            {datos.disponibles.map((t) => (
              <div key={t.id} className="agenda-home-tema" role="button"
                style={{ ["--agenda-color" as any]: colorCategoria(t.categoria) }}
                onClick={() => history.push(`/agenda/tema/${t.id}`)}>
                <strong>{t.titulo}</strong>
                <span>{t.mis_activas > 0 ? "Ya tenés cita" : t.inscripcion_abierta ? "Reservar turno" : "Próximamente"}</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default AgendaHomeCard;
